import type { RootDispatch, RootState } from '../../../configuration/setup/store';
import { trace } from '../../../configuration/setup/trace';
import { propagateRoutes } from '../../../features/livemonitorCommunication/MapRouteRendering';
import { updateItineraryWaypoints } from '../../../features/search/updateItineraryWaypoint';
import { updateWaypointsRange } from '../../../features/search/updateWaypointsRange';
import { selectItineraries } from '../../tour/tourSelectors';
import { updateSelectedItinerary } from '../../tour/tourSlice';

export const MAP_ROUTE_SELECTED_EVENT = 'EVENT_MAP_ROUTE_SELECTED';

type MapRouteSelectedType = {
    data?: {
        routeId?: string;
    };
};

export const mapRouteSelectedHandler = (
    data: MapRouteSelectedType,
    dispatch: RootDispatch,
    getState: () => RootState
) => {
    const routeId = data?.data?.routeId;
    const itineraries = selectItineraries(getState());
    if (!itineraries || !routeId) {
        trace.error('No itineraries available or missing routeId');
        return;
    }

    const key = itineraries.findIndex(it => it.itineraryId === routeId);
    if (key < 0) {
        trace.error('Invalid routeId, itinerary not found:', routeId);
        return;
    }

    dispatch(updateSelectedItinerary(key));
    dispatch(updateWaypointsRange(itineraries, key));
    dispatch(propagateRoutes(itineraries, key));
    dispatch(updateItineraryWaypoints);
};
